import React from 'react'

import s from './PageHeader.scss'
// import pattern from 'static/images/pattern.png'

export default props => {
  const { children } = props

  return (
    <div
      className={s.header}
      // style={{ backgroundImage: `url(${pattern})` }}
    >
      {children}
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Page/PageHeader/PageHeader.jsx